const CLIENT_ERROR_MIN = 400
const CLIENT_ERROR_MAX = 499

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null

// Array.isArray narrows to any[]; this keeps the element type as unknown.
const isUnknownArray = (value: unknown): value is readonly unknown[] =>
  Array.isArray(value)

// Covers RTK Query errors ({ status }), generic fetch/HTTP errors ({ statusCode })
// and Sentry response contexts ({ status_code }).
const httpStatusOf = (value: unknown): number | undefined => {
  if (!isRecord(value)) {
    return undefined
  }

  if (
    value.status === "PARSING_ERROR" &&
    typeof value.originalStatus === "number"
  ) {
    return value.originalStatus
  }

  for (const key of ["status", "statusCode", "status_code"]) {
    if (typeof value[key] === "number") {
      return value[key]
    }
  }

  return undefined
}

const hasClientErrorStatus = (value: unknown): boolean => {
  const status = httpStatusOf(value)

  return (
    status !== undefined &&
    status >= CLIENT_ERROR_MIN &&
    status <= CLIENT_ERROR_MAX
  )
}

// Array candidates are captured console.error arguments.
export const isClientError = (candidates: readonly unknown[]): boolean =>
  candidates.some((candidate) =>
    isUnknownArray(candidate)
      ? isClientError(candidate)
      : hasClientErrorStatus(candidate),
  )
